export default "__VITE_ASSET__Bac7bYPM__"